import useCampaignsData from "@/modules/common/hooks/campaigns-data.hook";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import type { UUID } from "crypto";
import type { SyntheticEvent } from "react";
import { useContext, useState } from "react";

const useEditAd = () => {
  const { lead } = useContext(LeadPageContext);
  const [editAdModalOpen, setEditAdModalOpen] = useState(false);
  const [ad, setAd] = useState<{
    label: string;
    uid: UUID | string;
  } | null>(null);

  const handleChangeAd = (
    _event: SyntheticEvent<Element, Event>,
    value: { label: string; uid: UUID | string } | null
  ) => {
    setAd(value || null);
  };
  const { Ads } = useCampaignsData();
  return {
    ad: {
      editAdModalOpen,
      setEditAdModalOpen,
      handleChangeAd,
      AdsData: Ads,
      state: ad,
      setState: setAd,
      value: lead?.data?.lead?.ad?.name,
    },
  };
};

export default useEditAd;
